export const TRACK_TYPES = {
  VIDEO: 'video',
  AUDIO: 'audio',
};

export const TRACK_ACTIONS = {
  MUTE: 'mute',
  UNMUTE: 'unmute',
};
